import React, { useEffect, useState } from "react";
import { getData } from "../Api";

function Hero() {
  const [sliders, setSliders] = useState([]);

  useEffect(() => {
    const fetchCarouselData = async () => {
      try {
        const response = await getData("/sliders");

        if (response.success) {
          setSliders(response.data);
        }
      } catch (error) {
        console.error("Error fetching slider data:", error);
      }
    };

    fetchCarouselData();
  }, []);

  return (
    <div className="row">
      <div id="carouselExampleIndicators" className="carousel slide p-0 ajent-buttion" data-bs-ride="carousel">
        <div className="carousel-inner">
          {sliders.length > 0 ? (
            sliders.map((item, index) => (
              <div
                key={item.id}
                className={`carousel-item ggg ${index === 0 ? "active" : ""}`}
                style={{
                  backgroundImage: `url('/assets/img/banner.webp')`,
                 
   
                }}
              >
              </div>
            ))
          ) : (
            <div className="carousel-item active" style={{ height: "500px", background: "#ccc" }}>
              Loading...
            </div>
          )}
        </div>

        {/* Previous Button */}
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>

        {/* Next Button */}
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>

        {/* Indicators */}
        <div className="carousel-indicators">
          {sliders.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Hero;
